/* unplugin-vue-components disabled */import script from "./DishesOrderCustomerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DishesOrderCustomerCard.vue?vue&type=script&setup=true&lang=js"

import "./DishesOrderCustomerCard.vue?vue&type=style&index=0&id=74b56c1d&lang=scss"

const __exports__ = script;

export default __exports__